import React from 'react';

import { IStore } from '~/src/dash/reducers/store';
import { decorate } from '~/src/dash/utils/decorator';
import { ResellerManagerView } from '~/src/dash/views/reseller-manager-view';

export const ResellerNewView = decorate(
  {
    redux: (state: IStore) => {
      return {
        session: state.session,
      };
    },
  },
  function () {
    return (
      <div>
        <ResellerManagerView
          reseller={{
            ID: '',
            Name: 'reseller-' + Date.now(),
            LogoURL: '',
          }}
        />
      </div>
    );
  },
);
